import { Component, EventEmitter, Input, OnChanges, Output, ViewChild } from '@angular/core';

import { noop } from 'underscore';

import { VbConfirmationDialogComponent } from 'rev-shared/ui/dialog/VbConfirmationDialogAngular.Component';

import { IVideoCommentMenuConfig } from './IVideoCommentMenuConfig';
import { VideoCommentMenuEventType } from './VideoCommentMenuContract';
import { VideoCommentService } from './VideoComment.Service';

import styles from './video-comment.module.less';

@Component({
	selector: 'video-comment',
	templateUrl: './VideoComment.Component.html'
})
export class VideoCommentComponent implements OnChanges {
	@Input() public comment: any;
	@Output() private onToggleRepliesDisplay: EventEmitter<{ commentId: string, showReplies: boolean; }> = new EventEmitter();
	@ViewChild(VbConfirmationDialogComponent) public deleteConfirmationDialog: VbConfirmationDialogComponent;

	public readonly styles = styles;

	public isAddReply: boolean;
	public commentMenuConfig: IVideoCommentMenuConfig;
	public isProcessing: boolean;

	constructor(
		private VideoCommentService: VideoCommentService
	) { }

	public ngOnChanges(): void {
		if (this.comment) {
			this.commentMenuConfig = this.getCommentMenuConfig();
		}
	}

	public onMenuItemClick({ eventType }: { eventType: VideoCommentMenuEventType; }) {
		switch (eventType) {
			case VideoCommentMenuEventType.Delete: {
				this.showDeleteCommentDialog();
				break;
			}
			case VideoCommentMenuEventType.Reply: {
				this.isAddReply = true;
				break;
			}
			case VideoCommentMenuEventType.ShowReplies: {
				this.toggleRepliesDisplay();
				break;
			}
		}
	}

	private showDeleteCommentDialog(): void {
		this.deleteConfirmationDialog.open().result
			.then(() => {
				this.deleteComment();
			})
			.catch(() => noop);
	}

	private deleteComment(): void {
		const comment = {
			id: this.comment.id,
			videoId: this.comment.videoId,
			parentCommentId: this.comment.parentCommentId
		};
		this.isProcessing = true;
		this.VideoCommentService.removeComment(comment)
			.finally(() => this.isProcessing = false);
	}

	private toggleRepliesDisplay(): void {
		this.commentMenuConfig.showReplies = !this.commentMenuConfig.showReplies;
		this.onToggleRepliesDisplay.emit({
			commentId: this.comment.id,
			showReplies: this.commentMenuConfig.showReplies
		});
	}

	private getCommentMenuConfig(): IVideoCommentMenuConfig {
		return {
			isCommentDeleted: this.comment.isRemoved,
			showDeleteComment: this.comment.canRemoveVideoComment,
			repliesCount: (this.comment.childComments || []).length,
			showReplies: this.comment.showReplies
		};
	}
}
